<template>
    <div class="flex items-center gap-2.5" :class="{ 'pointer-events-none opacity-40': disabled }">
        <img :src="imageUrl" alt="" class="size-10 shrink-0 rounded-md object-cover" />
        <div class="flex-1">
            <!-- The label alone, at the panel's own body size: the line under it explained what a
                 photo in a row marked "your photo" was for. -->
            <p class="text-base text-gray-700 md:text-sm">{{ label }}</p>
        </div>
        <button type="button" class="cursor-pointer text-xs text-gray-400 hover:text-gray-600" @click="emit('dismiss')">
            {{ changeLabel }}
        </button>
    </div>
</template>

<script setup lang="ts">
type PhotoSelectionBlockProps = {
    imageUrl: string;
    disabled?: boolean;
    label: string;
    changeLabel: string;
};

withDefaults(defineProps<PhotoSelectionBlockProps>(), {
    disabled: false,
});

const emit = defineEmits<{
    dismiss: [];
}>();
</script>
